<template>
  <div class="panel">
    <div class="panel-content">
      <p class="panel-title">Centre de descàrregues <q-spinner v-if="loading" /></p>
      <div class="categories" v-if="!loading">
        <q-input filled v-model="filter" label="Filtre" class="q-my-md"></q-input>
        <div v-if="downloads && downloads.length > 0">
          <q-list separator>
            <q-item
              v-for="download in downloadsFilter"
              v-bind:key="download.id"
            >
              <q-item-section>
                <q-item-label>{{ download.title }}</q-item-label>
                <q-item-label v-if="download.description" caption lines="2">{{ download.description }}</q-item-label>
              </q-item-section>
              <q-item-section side>
                <q-spinner v-if="openingFiles.includes(download.url)"></q-spinner>
                <q-btn
                  v-else
                  flat dense no-caps
                  icon="search"
                  @click="open(download)"
                >
                  <q-tooltip>{{ $t('actions.explore') | capitalize }}</q-tooltip>
                </q-btn>
              </q-item-section>
            </q-item>
          </q-list>
        </div>
        <div v-else>
          No hi ha descàrregues disponibles
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QBtn, QItem, QItemLabel, QItemSection, QInput, QList, QSpinner, QTooltip } from 'quasar'
import axios from 'axios'
import { saveAs } from 'file-saver'

import { mapState } from 'vuex'

export default {
  name: 'HomePanel',
  components: {
    QBtn, QItem, QItemLabel, QItemSection, QInput, QList, QSpinner, QTooltip
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.q = to.params.q
      vm.$store.dispatch('catalogTree/checkCategories')
    })
  },
  beforeRouteUpdate (to, from, next) {
    let vm = this
    vm.q = to.params.q
    vm.$store.dispatch('catalogTree/checkCategories')
    next()
  },
  data () {
    return {
      filter: '',
      openingFiles: []
    }
  },
  computed: {
    ...mapState({
      catalog: state => state.catalogTree.catalog,
      downloads: state => state.downloads.downloads,
      loading: state => state.catalogTree.loading
    }),
    downloadsFilter () {
      return this.downloads.filter(download => download.title.toLowerCase().includes(this.filter.toLowerCase()))
    }
  },
  methods: {
    open (download) {
      const url = download.url
      this.openingFiles.push(url)
      const headers = this.$store.getters['auth/headers']
      const conf = {
        headers: headers,
        responseType: 'arraybuffer'
      }
      axios.get(url, conf).then(response => {
        const contentType = response.headers['content-type']
        const fileBlob = new Blob([response.data], { type: contentType })
        if (this.$config.components.resultTabs.infoTab.previewContentTypes.includes(contentType)) {
          const fileURL = window.URL.createObjectURL(fileBlob)
          window.open(fileURL)
        } else {
          const fileName = url.split('/').pop()
          saveAs(fileBlob, fileName)
        }
        this.openingFiles = this.openingFiles.filter(file => file !== url)
      }).catch(error => {
        this.openingFiles = this.openingFiles.filter(file => file !== url)
        this.$except(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
